import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
//Create custom component to export
var RatingDisplay = function RatingDisplay(props, _ref) {
  var $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var starValues = [1, 2, 3, 4, 5];
  var starLabel = props.starLabel;
  var starRating = props.starRating;
  var userLabel = props.userLabel;
  var userComments = props.userComments;
  var userData = props.userRatingData;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          starRating = userData.LoanRating;
          userComments = userData.UserComments;
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div>
  <div class="block-title">${props.starLabel}:</div>
  <div class="block block-strong inset justify-content-center">
  ${starValues.map((list, i) => $h`
    <i class="icon material-symbols-rounded ${i < starRating && $h`color-orange`}">star_rate</i>
  `)}
  </div>
  <div class="block-title">${props.userLabel}:</div>
  <div class="block block-strong inset">
    ${userComments}
  </div>
</div>
`
    }
    ;
};
//Export component name
export default RatingDisplay;

//On template use:
//<${RatingDisplay} user-rating-data={LoaRating:4, UserComments:'Good service'} star-label="Borrower rating" user-label="Borrower comments" />